import axios from "axios";

// const API_ADMIN = "http://127.0.0.1:8000/api/admin";
// const API_GESTIONNAIRE = "http://127.0.0.1:8000/api/gestionnaire";

// const API_ADMIN = "http://192.168.122.63:8000/api/admin";
// const API_GESTIONNAIRE = "http://192.168.122.63:8000/api/gestionnaire";


const API_ADMIN = `${process.env.REACT_APP_API_URL}/api/admin`;
const API_GESTIONNAIRE = `${process.env.REACT_APP_API_URL}/api/gestionnaire`;

export default class BrevetService {
  static getApiUrl(role) {
    return role === "admin" ? API_ADMIN : API_GESTIONNAIRE;
  }

  static async getBrevet(role, token) {
    try {
      const url = `${this.getApiUrl(role)}/brevets`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des brevets :", error);
      throw error;
    }
  }

  static async getBrevetById(role, token, id) {
    try {
      const url = `${this.getApiUrl(role)}/brevets/${id}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du brevet :", error.response?.data || error.message);
      throw error;
    }
  }

  static async addBrevet(role, token, newBrevet) {
    try {
      const url = `${this.getApiUrl(role)}/brevets`;
      const formData = newBrevet;
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'ajout du brevet:", error.response?.data || error.message);
      throw error;
    }
  }
  static async updateBrevet(role, token, id, formData) {
    try {
      const url = `${this.getApiUrl(role)}/brevets/${id}`;

      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erreur lors de la modification du brevet :", error.response?.data || error.message);
      throw error;
    }
  }

  static async deleteBrevet(role, token, id) {
    try {
      const url = `${this.getApiUrl(role)}/brevets/${id}`;
      const response = await axios.delete(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la suppression du brevet :", error);
      throw error;
    }
  }

  static async calculateBrevetBudget(role, token, data) {
    try {
      const url = `${this.getApiUrl(role)}/calculate-budget`;

      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Erreur lors du calcul du budget :", error.response?.data || error.message);
      throw error;
    }
  }

  static async getCountries(role, token) {
    try {
      const url = `${this.getApiUrl(role)}/annuity-countries`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des pays :", error);
      throw error;
    }
  }

  static async getComptesComptables(role, token, societeId) {
    try {
      const url = `${this.getApiUrl(role)}/comptes-comptables/by-societe`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: { societe_id: societeId },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du plan comptable :", error.response?.data || error.message);
      throw error;
    }
  }
}
